<template>
	<div class="content-page content-page--impact-form-read-only">
		<ActionSetNav
			v-if="navigatingFromCustomer && pageTitle"
			:name="pageTitle"
			:display="true"
			:actions="mainNavActions"
			ref="customerNav"
		/>
		<div class="content-page__heading">
			<div class="content-page__breadcrumb-title">
				<Breadcrumbs :items="urlNames" />
				<h2 class="content-page__title">Form Details</h2>
			</div>
			<div class="content-page__action" v-show="hasUpdatePermission">
				<Button
					labelText="Edit in Designer"
					:btnClick="editForm"
					:iconBeforeLabel="true"
				/>
			</div>
		</div>
		<!-- DEV NOTES: BlockNotifications component is missing the option to display the status icon based on notification requirement. -->
		<BlockContainer>
			<BlockNotifications
				title="Shared Form"
				message="This form is shared by multiple clients. Changes will be applied to the form for all assigned clients.
				If changes are unique to one client, create a copy of this form from the Forms Manager for the specific client."
			/>
		</BlockContainer>
		<Spinner :processor="{ loading: loadingSource }" />
		<div v-if="hasFormValue">
			<ImpactDetails
				@hasErrors="val => (hasErrorModal = val)"
				v-model="form"
			/>
		</div>
	</div>
</template>

<script>
import ActionSetNav from '@/site-components/actions-set/action-set-nav';
import Breadcrumbs from '@/components/shells/breadcrumbs/breadcrumbs.vue';
import Button from '@/components/forms/button/button';
import BlockContainer from '@/components/notifications/block-notifications/block-notifications-container';
import BlockNotifications from '@/components/notifications/block-notifications/block-notifications';
import ImpactDetails from '@/views/form-designer/impact-details.vue';
import Spinner from '@/components/visual/spinner/spinner';

// mixins
import FormsReadonlyMixins from '@/mixins/forms/forms_readonly';

export default {
	components: {
		ActionSetNav,
		Breadcrumbs,
		Button,
		BlockContainer,
		BlockNotifications,
		Spinner,
		ImpactDetails
	},
	name: 'ImpactFormDesignerReadOnly',
	mixins: [FormsReadonlyMixins]
};
</script>

<style lang="scss" scoped>
/**
  * [Description]
  *
  * Impact Form details
  * Can use SCSS variables = TRUE
  *
  *
**/

.content-page {
	@include mq($until: md) {
		&__heading {
			margin: $gutter-xl $gutter-md;
		}
	}
	&__action {
		@include mq($until: md) {
			width: 100%;
			display: flex;
			justify-content: flex-end;
		}
	}
}
</style>
